import { getConsentEnv } from "@/services/consent/env";

import ConsentService from "./consent-service";
import DefaultConsentService from "./default-consent-service";
import DevConsentService from "./dev-consent-service";

export function createConsentService(): ConsentService {
  return getConsentEnv().isDevelopmentLike
    ? new DevConsentService()
    : new DefaultConsentService();
}
